var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 64.2869V46.4299H55.665C56.9899 46.4007 58.3071 46.6387 59.538 47.1299C60.58 47.5514 61.5185 48.1934 62.289 49.0117C63.0596 49.8301 63.6439 50.8056 64.002 51.8711C64.3844 52.9836 64.5757 54.1525 64.568 55.3288C64.5855 56.5853 64.3723 57.8344 63.939 59.0139C63.5463 60.0703 62.9327 61.0308 62.139 61.831C61.337 62.625 60.3773 63.242 59.322 63.6421C58.1526 64.0821 56.9113 64.2994 55.662 64.2829L49 64.2869ZM60.368 55.333C60.3769 54.604 60.2709 53.8779 60.054 53.1819C59.862 52.5691 59.5499 52.0009 59.136 51.51C58.7318 51.0395 58.2238 50.6693 57.652 50.4289C57.0223 50.1689 56.3462 50.0403 55.665 50.051H53.125V60.665H55.665C56.3567 60.6787 57.0431 60.5421 57.677 60.2649C58.2468 60.0098 58.7501 59.627 59.148 59.146C59.5532 58.6464 59.8603 58.0746 60.053 57.4609C60.2692 56.7729 60.3755 56.0551 60.368 55.334V55.333Z",
    fill: "#153959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9936 64.5391C71.9742 64.5552 70.9614 64.3713 70.0126 63.9981C69.1741 63.6655 68.4125 63.1649 67.7746 62.5271C67.1652 61.9143 66.6886 61.1822 66.3746 60.377C66.056 59.5636 65.8938 58.6975 65.8966 57.824C65.8912 56.9025 66.0532 55.9877 66.3746 55.124C66.6811 54.2965 67.1515 53.5393 67.7576 52.898C68.3855 52.2443 69.1439 51.7301 69.9836 51.3889C70.9386 51.0056 71.9607 50.8173 72.9896 50.835C74.0144 50.8166 75.0323 51.005 75.9826 51.3889C76.8151 51.7322 77.5684 52.2428 78.1956 52.8889C78.7964 53.5131 79.2629 54.2536 79.5666 55.065C79.8783 55.8931 80.0362 56.7712 80.0326 57.656C80.0326 57.891 80.0236 58.1209 80.0076 58.3479C79.9945 58.5466 79.9695 58.7443 79.9326 58.94H70.1806C70.1881 59.3269 70.2783 59.7078 70.4453 60.0569C70.6123 60.406 70.8521 60.7154 71.1486 60.9641C71.7058 61.418 72.404 61.6627 73.1226 61.656C73.7157 61.6553 74.2996 61.5087 74.8226 61.229C75.3199 60.9948 75.7106 60.5816 75.9166 60.072L79.3366 61.0281C78.7953 62.0912 77.9566 62.974 76.9226 63.5691C75.7267 64.2468 74.3675 64.5823 72.9936 64.5391ZM75.7856 56.439C75.7416 55.6871 75.4189 54.9787 74.8806 54.4519C74.3558 53.9639 73.66 53.702 72.9436 53.7229C72.5857 53.7105 72.2289 53.7698 71.8942 53.8972C71.5595 54.0246 71.2537 54.2178 70.9946 54.4651C70.4675 54.9931 70.1501 55.6945 70.1016 56.439H75.7856Z",
    fill: "#153959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2031 64.287V46.4301H89.8241C90.6385 46.4207 91.4439 46.6015 92.1761 46.9581C92.8712 47.2971 93.4946 47.7667 94.0121 48.3412C94.5236 48.9121 94.9319 49.5676 95.2191 50.2782C95.5069 50.9719 95.6563 51.7152 95.6591 52.4662C95.6619 53.24 95.5212 54.0076 95.2441 54.7301C94.9751 55.4387 94.5834 56.0943 94.0871 56.6671C93.5882 57.2402 92.9751 57.7026 92.2871 58.025C91.555 58.3656 90.7555 58.5365 89.9481 58.525H86.3261V64.285L82.2031 64.287ZM86.3281 54.931H89.6981C89.9419 54.9289 90.1819 54.8713 90.4 54.7623C90.618 54.6533 90.8082 54.4959 90.9561 54.3021C91.3429 53.7714 91.5298 53.1213 91.4841 52.4662C91.4921 52.0991 91.4366 51.7333 91.3201 51.3851C91.2252 51.1067 91.0756 50.8499 90.8801 50.63C90.707 50.437 90.4918 50.2865 90.2511 50.1901C90.0285 50.1007 89.791 50.054 89.5511 50.0521H86.3321L86.3281 54.931Z",
    fill: "#153959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.289 64.5391C100.668 64.5447 100.05 64.4384 99.4662 64.2252C98.938 64.0365 98.4532 63.7431 98.0409 63.3628C97.6285 62.9826 97.297 62.5232 97.0662 62.012C96.8285 61.487 96.7083 60.9165 96.7142 60.3401C96.7061 59.72 96.8485 59.107 97.1292 58.554C97.4111 58.0112 97.8108 57.5383 98.2992 57.17C98.8373 56.7667 99.4418 56.4604 100.085 56.2649C100.827 56.0391 101.599 55.9289 102.374 55.938C102.914 55.9371 103.453 55.9835 103.984 56.077C104.453 56.1539 104.91 56.2935 105.342 56.492V55.8921C105.342 54.3668 104.462 53.6037 102.701 53.6031C101.998 53.6003 101.299 53.7239 100.639 53.9681C99.9113 54.2504 99.2191 54.6176 98.5772 55.0621L97.3952 52.5472C98.2348 51.9924 99.1494 51.5601 100.111 51.264C101.082 50.9742 102.091 50.83 103.104 50.836C104.767 50.7299 106.411 51.2307 107.732 52.2452C108.295 52.7673 108.734 53.4086 109.017 54.1224C109.3 54.8361 109.42 55.6042 109.367 56.3702V59.7701C109.34 60.064 109.406 60.359 109.556 60.6131C109.643 60.7033 109.746 60.7751 109.861 60.8248C109.975 60.8744 110.098 60.9008 110.223 60.9022V64.3021C109.909 64.3795 109.589 64.4344 109.267 64.4661C108.982 64.4908 108.722 64.5033 108.487 64.504C107.885 64.5456 107.285 64.3913 106.777 64.064C106.384 63.7577 106.123 63.3122 106.048 62.8191L105.973 62.219C105.415 62.9503 104.696 63.5442 103.873 63.9551C103.069 64.3487 102.184 64.5487 101.289 64.5391ZM102.471 61.6461C102.905 61.6465 103.335 61.5699 103.741 61.42C104.118 61.2906 104.464 61.0866 104.76 60.8201C104.924 60.7167 105.062 60.5764 105.163 60.4105C105.263 60.2445 105.324 60.0574 105.339 59.8641V58.606C104.968 58.4666 104.585 58.3615 104.195 58.292C103.818 58.2195 103.435 58.1813 103.051 58.178C102.406 58.1508 101.769 58.3256 101.228 58.678C101.007 58.817 100.825 59.0102 100.7 59.2391C100.575 59.468 100.51 59.7251 100.511 59.9861C100.506 60.2144 100.553 60.4408 100.648 60.648C100.744 60.8552 100.887 61.0375 101.064 61.181C101.461 61.501 101.961 61.6666 102.47 61.647L102.471 61.6461Z",
    fill: "#153959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.381 66.2741C112.688 66.3843 113.003 66.4685 113.324 66.5261C113.586 66.5732 113.851 66.5983 114.116 66.601C114.331 66.6126 114.545 66.5734 114.742 66.4865C114.939 66.3996 115.112 66.2675 115.248 66.101C115.607 65.5508 115.855 64.9355 115.977 64.29L110.947 51.09H115.097L118.165 60.8491L120.806 51.09H124.579L119.549 66.433C119.213 67.5169 118.533 68.4616 117.611 69.1242C116.69 69.7868 115.578 70.1309 114.443 70.1049C114.102 70.1045 113.761 70.0752 113.424 70.017C113.068 69.9548 112.718 69.858 112.38 69.728L112.381 66.2741Z",
    fill: "#153959"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5041 40.0083C96.1714 40.0083 104.008 32.1714 104.008 22.5041C104.008 12.8369 96.1714 5 86.5041 5C76.8369 5 69 12.8369 69 22.5041C69 32.1714 76.8369 40.0083 86.5041 40.0083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2168 16.8521C75.9389 15.5988 78.2213 15.4328 81.176 16.1881C81.3254 15.4743 81.4914 14.7854 81.6906 14.1463C78.047 13.2749 75.1587 13.6152 74.171 15.3166C72.785 17.7152 75.6318 22.0311 80.7112 25.6913C80.6863 25.4506 80.6697 25.2099 80.6531 24.9609C76.5447 21.9232 74.2042 18.6033 75.2168 16.8521Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6528 24.9609C79.217 23.8985 77.9969 22.803 77.0673 21.7572C76.9345 21.89 76.8017 22.0145 76.6689 22.1473C77.7562 23.3424 79.134 24.5459 80.7192 25.6913C80.6943 25.4506 80.6694 25.2099 80.6528 24.9609Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8809 15.9141C80.2958 15.9888 80.7274 16.0801 81.1756 16.1963C81.325 15.4826 81.491 14.7937 81.6902 14.1546C81.242 14.0467 80.8021 13.9554 80.3705 13.889C80.1879 14.5281 80.022 15.2087 79.8809 15.9141Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.292 23.8902C79.3003 24.1392 79.3169 24.3881 79.3252 24.6288C79.7651 24.9857 80.2299 25.3426 80.7112 25.6912C80.6864 25.4505 80.6697 25.2098 80.6532 24.9608C80.1718 24.6039 79.7236 24.247 79.292 23.8902Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1478 19.0929C92.2391 20.0059 92.2972 20.952 92.3138 21.9148C95.9076 24.7699 97.8664 27.7578 96.9285 29.3846C96.2396 30.5714 94.1481 30.7872 91.3926 30.1565C91.3428 30.339 91.293 30.5133 91.2432 30.6959C94.8867 31.5674 97.7917 31.2354 98.7793 29.5257C100.165 27.1188 97.2854 22.7614 92.1478 19.0929Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2061 23.5831C94.5713 23.94 94.9116 24.2969 95.2187 24.6538C95.7582 24.1807 96.2728 23.6993 96.7375 23.2179C96.3392 22.7531 95.8993 22.28 95.4262 21.8153C94.48 20.8857 93.6417 23.027 94.2061 23.5831Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9575 21.6327C92.2397 21.8568 92.5468 22.0892 92.8041 22.3133C92.8041 22.2884 92.8041 22.2386 92.8041 22.2137C92.8041 21.2758 92.746 20.3712 92.6796 19.4748C92.3974 19.259 92.082 19.0515 91.7832 18.844C91.8745 19.7487 91.9409 20.6616 91.9575 21.6327Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0819 30.8786C92.1317 30.696 92.1815 30.5134 92.223 30.3308C91.9491 30.281 91.6752 30.2312 91.3847 30.1648C91.3349 30.3474 91.2851 30.5217 91.2354 30.7043C91.5258 30.7624 91.808 30.8205 92.0819 30.8786Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2661 28.0649C74.2618 26.322 76.5774 23.0187 80.6526 19.9976C80.6692 19.7486 80.6941 19.5079 80.719 19.2672C75.6644 22.9108 72.8425 27.2184 74.2203 29.6087C75.1997 31.3018 78.0548 31.6504 81.6652 30.7956C81.4743 30.1565 81.3083 29.4676 81.1589 28.7538C78.2374 29.4842 75.9881 29.3099 75.2661 28.0649Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.661 19.9976C80.6776 19.7486 80.7025 19.5079 80.7274 19.2672C80.246 19.6158 79.7812 19.9727 79.333 20.3296C79.3164 20.5786 79.3081 20.8276 79.2998 21.0766C79.7231 20.7114 80.1796 20.3545 80.661 19.9976Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6653 30.7956C81.4744 30.1565 81.3084 29.4676 81.159 28.7538C80.7108 28.87 80.2792 28.9613 79.8643 29.0277C80.0054 29.7332 80.163 30.4138 80.3456 31.0611C80.7772 30.9864 81.2171 30.8952 81.6653 30.7956Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8291 15.3996C97.8415 13.6815 94.9033 13.3495 91.2266 14.2459C91.2764 14.4202 91.3262 14.6028 91.376 14.7771C94.1564 14.1214 96.2894 14.3289 96.9783 15.5324C97.9245 17.1674 95.9408 20.1719 92.3138 23.0436C92.2972 24.0147 92.2474 24.9526 92.1561 25.8655C97.3186 22.1887 100.223 17.8148 98.8291 15.3996Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3681 14.7771C91.6586 14.7107 91.9325 14.6526 92.2064 14.6028C92.1566 14.4202 92.1151 14.2376 92.0653 14.055C91.7914 14.1131 91.5092 14.1712 91.2188 14.2376C91.2768 14.4202 91.3266 14.6028 91.3681 14.7771Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.119 22.3797C92.8617 22.6038 92.5878 22.8279 92.3139 23.0437C92.2973 24.0148 92.2475 24.9526 92.1562 25.8656C92.455 25.6581 92.7455 25.4423 93.0277 25.2265C93.0941 24.3384 93.1273 23.4255 93.1273 22.5042C93.119 22.4627 93.119 22.4212 93.119 22.3797Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4465 36.705C83.2013 36.705 80.5703 30.3474 80.5703 22.5041C80.5703 14.6609 83.2013 8.30329 86.4465 8.30329C89.6917 8.30329 92.3227 14.6609 92.3227 22.5041C92.3227 30.3474 89.6917 36.705 86.4465 36.705ZM87.2516 35.0285C84.7617 35.0285 82.7448 29.4178 82.7448 22.4958C82.7448 15.5739 84.7617 9.96323 87.2516 9.96323C89.7415 9.96323 91.7584 15.5739 91.7584 22.4958C91.7584 29.4178 89.7415 35.0285 87.2516 35.0285Z",
    fill: "url(#paint4_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 76.6661,
    y1: 14.2932,
    x2: 82.5204,
    y2: 23.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    stopColor: "#447FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6614,
    stopColor: "#3E74AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 92.3062,
    y1: 24.401,
    x2: 97.4956,
    y2: 32.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3119,
    stopColor: "#447FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6614,
    stopColor: "#3E74AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 76.9024,
    y1: 21.8426,
    x2: 79.2736,
    y2: 34.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#F3DA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#F6EFD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 92.8677,
    y1: 13.2767,
    x2: 97.1796,
    y2: 25.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3349,
    stopColor: "#F3DA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8942,
    stopColor: "#F6EFD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 86.6338,
    y1: 35.8767,
    x2: 86.2973,
    y2: 12.2317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0901605,
    stopColor: "#CC296B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5746,
    stopColor: "#FF3387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF87B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.579,
    height: 65.097,
    fill: "white",
    transform: "translate(49 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(69 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDePay);
export default __webpack_public_path__ + "static/media/dePay.d9f4b3f54064570ed984d592fd032a7f.svg";
export { ForwardRef as ReactComponent };